var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 989,
    height: 559,
    viewBox: "0 0 989 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1301.71 498.625C1301.71 783.788 1557.58 985.939 1186.02 985.939C814.457 985.939 7.34382e-05 840.035 4.85085e-05 554.872C2.35787e-05 269.709 497.944 -4.35316e-05 869.504 -7.60145e-05C1241.06 -0.000108497 1301.71 213.462 1301.71 498.625Z",
    fill: "#9893FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor1);
export default __webpack_public_path__ + "static/media/decor1.15fc927ac9164f46be52e3aa9b7656d2.svg";
export { ForwardRef as ReactComponent };